<template>
  <div>
    <h4 class="card-title" v-if="header">{{ header }}</h4>
    <KDraggableField
      class="file-card md-layout md-alignment-center-center"
      v-bind:class="{ error: error, }"
      :exe="() => ($refs.file && $refs.file.click())"
      :disabled="disabled"
      @input="onFileChange($event)"
    >
      <!-- No Tiene Logo desde backend -->
      <div
        v-bind:class="{ activate: error, }"
        v-if="!imageFile"
        class="md-layout-item md-layout md-alignment-center-center"
      >
        <img :src="imageDefault" />
        <p class="input-placeholder">Haga click o arrastre archivo</p>
      </div>
      <!-- tiene Imagen desde Backend-->
      <div
        v-else
        v-bind:class="{ activate: error, }"
        class="md-layout md-layout-item md-alignment-center-center"
        style="flex-direction: column;"
      >
        <!-- from file -->
        <img v-if="toShow" :src="toShow" title class="md-layout-item mx-auto" />
        <!-- from backend -->
        <img v-else-if="imageFile" :src="imageFile" title name="image" />
        <p class="input-placeholder">Haga click o arrastre archivo</p>
      </div>
    </KDraggableField>
    <div v-show="imageFile" class="button-container" style="margin-top: 4px;">
      <md-button class="md-danger md-round" @click="removeImage">
        <md-icon>close</md-icon>Quitar
      </md-button>
    </div>
    <input ref="file" style="display: none;" type="file" @change="onFileChange" />
    <div
      v-if="error"
      class="text-center text-error"
    >* Las imagen no fue tomada este día o no puede ser validada.</div>
  </div>
</template>

<script>
import validateImageData from "../../utils/validateImageData";
import KDraggableField from "@/components/Inputs/KDraggableField";

export default {
  name: "ImageField",
  components: {
    KDraggableField,
  },

  props: {
    fieldName: {
      type: String,
      default: "logo",
    },
    useBase64: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: null,
    },
    todayImage: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      toShow: "",
      imageDefault: require("@/assets/images/image_placeholder.jpg"),
      imageFile: null,
      readedImage: null,
      editedObject: {},
      error: null,
    };
  },

  computed: {
    objectImage: {
      get() {
        return this.editedObject[this.fieldName];
      },
      set(value) {
        this.editedObject[this.fieldName] = value;
      },
    },
  },

  mounted() {
    const img = this.objectImage;
    if (img) {
      this.imageFile = img;
    }
  },

  methods: {
    onFileChange(e) {
      if (this.disabled) return;
      const files = e && e.target ? e.target.files || e.dataTransfer.files : e;
      if (!files.length) return; //Multiples Images selected
      const file = files[0];
      this.createImage(file);
    },

    createImage(file) {
      validateImageData(file).then((newImg) => {
        this.error = false;
        if (this.todayImage) {
          if (newImg.error) {
            this.$notify({
              message: "Asegurse de subir una foto de este día.",
              icon: "close",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
            this.error = true;
          }
        }
        this.toShow = newImg.src;
        this.imageFile = newImg.file;
        if (this.useBase64) {
          this.objectImage = newImg.src;
        } else {
          this.objectImage = newImg.file;
        }
        this.readedImage = newImg.src;
      });
    },

    removeImage() {
      this.objectImage = null;
      this.imageFile = null;
      this.error = false;
    },
  },

  watch: {
    imageFile(value) {
      if (!this.error) this.$emit("loadedImage", value);
      else this.$emit("loadedImage", null);
    },
    readedImage(value) {
      if (!this.error) this.$emit("readedImage", value);
      else this.$emit("readedImage", null);
    },
  },
};
</script>

<style lang="css" scoped>
.activate {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.6;
}
.error {
  box-shadow: 0px 0px 20px 3px red;
}
.text-error {
  color: red;
}
img {
  width: 100%;
}
.input-placeholder {
  color: green;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Inputs/ImageInput.vue